import API from '../api'

const createInquiry = (data) => API.post('/api/v4/inquiry', data);

const FAQAPI = {
  createInquiry
}

export default FAQAPI
